import { render, staticRenderFns } from "./noActiveDataReport.vue?vue&type=template&id=904d43e8&scoped=true"
import script from "./noActiveDataReport.vue?vue&type=script&lang=js"
export * from "./noActiveDataReport.vue?vue&type=script&lang=js"
import style0 from "./noActiveDataReport.vue?vue&type=style&index=0&id=904d43e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904d43e8",
  null
  
)

export default component.exports